<template>
  <div>
    <vue-element-loading
      :active="loading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="snackbar" :color="snackbarColor" right top>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false"> Close </v-btn>
      </template>
    </v-snackbar>

    <v-layout wrap justify-center>
      <v-flex xs12 md8 lg6>
        <v-card class="elevation-2 rounded-lg pa-6">
          <v-layout wrap>
            <v-flex xs12 mb-4>
              <span class="itemHeading" style="color: #005f32">Troubleshoot / Report Issue</span>
              <p class="kumbhRegular mt-2 grey--text text--darken-1">
                Found a bug or having attendance issues? Report it here and our team will look into it.
              </p>
            </v-flex>

            <v-flex xs12>
              <v-form ref="reportForm" v-model="valid" lazy-validation>
                <v-layout wrap>
                  <!-- Issue Description -->
                  <v-flex xs12 mb-4>
                    <v-textarea
                      v-model="description"
                      label="Detailed Description"
                      placeholder="Please describe the issue in detail..."
                      outlined
                      dense
                      rows="5"
                      :rules="[v => !!v || 'Description is required']"
                      color="#005f32"
                      prepend-inner-icon="mdi-text-box-outline"
                      class="rounded-lg"
                    ></v-textarea>
                  </v-flex>

                  <!-- Attendance Date (Commented out for now) -->
                  <!-- <v-flex xs12 mb-4>
                    <v-menu
                      v-model="dateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="attendanceDate"
                          label="Attendance Date (Optional)"
                          placeholder="Select date if this is an attendance issue"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          outlined
                          dense
                          v-bind="attrs"
                          v-on="on"
                          color="#005f32"
                          class="rounded-lg"
                          clearable
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="attendanceDate"
                        no-title
                        @input="dateMenu = false"
                        color="#005f32"
                        :max="new Date().toISOString().substr(0, 10)"
                      ></v-date-picker>
                    </v-menu>
                    <small class="grey--text pl-2">Fill this only if the issue is related to a specific day's attendance.</small>
                  </v-flex> -->

                  <!-- Screenshots Upload -->
                  <v-flex xs12 mb-6>
                    <v-file-input
                      v-model="screenshots"
                      label="Upload Screenshots (Optional)"
                      placeholder="Select up to 5 images"
                      prepend-inner-icon="mdi-camera"
                      prepend-icon=""
                      outlined
                      dense
                      multiple
                      chips
                      show-size
                      counter
                      :rules="[
                        v => !v || v.length <= 5 || 'Max 5 screenshots allowed'
                      ]"
                      color="#005f32"
                      accept="image/*"
                      class="rounded-lg"
                    >
                      <template v-slot:selection="{ index, text }">
                        <v-chip
                          v-if="index < 2"
                          color="#005f32"
                          dark
                          label
                          small
                        >
                          {{ text }}
                        </v-chip>
                        <span
                          v-else-if="index === 2"
                          class="text-overline grey--text text--darken-3 mx-2"
                        >
                          +{{ screenshots.length - 2 }} File(s)
                        </span>
                      </template>
                    </v-file-input>
                  </v-flex>

                  <!-- Actions -->
                  <v-flex xs12 text-right>
                    <v-btn
                      color="#005f32"
                      dark
                      large
                      class="rounded-xl px-8 kumbhBold white--text"
                      elevation="2"
                      :loading="loading"
                      @click="submitReport"
                    >
                      Submit Report
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "TroubleshootReport",
  data() {
    return {
      loading: false,
      valid: true,
      description: "",
      attendanceDate: null,
      dateMenu: false,
      screenshots: [],
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
    };
  },
  methods: {
    async submitReport() {
      if (!this.$refs.reportForm.validate()) return;

      this.loading = true;
      try {
        const formData = new FormData();
        formData.append("description", this.description);
        
        if (this.attendanceDate) {
          formData.append("attendanceDate", this.attendanceDate);
        }

        if (this.screenshots && this.screenshots.length > 0) {
          this.screenshots.forEach((file) => {
            formData.append("screenshots", file);
          });
        }

        const response = await axios({
          method: "POST",
          url: "/troubleshoot/report",
          data: formData,
          headers: {
            "x-auth-token": localStorage.getItem("token"),
            "Content-Type": "multipart/form-data",
          },
        });

        if (response.data.status) {
          this.showSnackbar(response.data.msg || "Issue reported successfully", "success");
          this.resetForm();
          // Optionally redirect after a short delay
          setTimeout(() => {
            this.$router.push("/Troubleshoot/MyTickets");
          }, 2000);
        } else {
          this.showSnackbar(response.data.msg || "Failed to report issue", "error");
        }
      } catch (error) {
        console.error("Report submission error:", error);
        this.showSnackbar(
          error.response?.data?.msg || "An error occurred while submitting the report",
          "error"
        );
      } finally {
        this.loading = false;
      }
    },
    resetForm() {
      this.description = "";
      this.attendanceDate = null;
      this.screenshots = [];
      if (this.$refs.reportForm) {
        this.$refs.reportForm.resetValidation();
      }
    },
    showSnackbar(text, color) {
      this.snackbarText = text;
      this.snackbarColor = color === "success" ? "#005f32" : "error";
      this.snackbar = true;
    },
  },
};
</script>

<style scoped>
.itemHeading {
  font-family: 'KumbhBold';
  font-size: 24px;
}
.kumbhRegular {
  font-family: 'KumbhRegular';
}
.kumbhBold {
  font-family: 'KumbhBold';
}
</style>
